import React from 'react'
import styled from '@emotion/styled'
import {ResetSectionPadding} from 'components/Accommodation/AccommodationView/Mobile/styles'
import {GuestTypeBadge} from 'components/Accommodation/GuestTypeBadge'
import {
  ReviewsTrackClick,
  SelectedElementType
} from 'components/Accommodation/ReviewsSection'
import {GuestType} from 'types/Hotel'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {HorizontalScroll} from '@vio/atlas/helpers/HorizontalScroll'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {Entity} from '@vio/core/src/analytics/types/Events'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {calculateGuestTypePercentages} from './utils'

const HorizontalScrollWrapper = styled(ResetSectionPadding)`
  padding-left: ${cssTheme.layout.spacing.s500};
  padding-right: ${cssTheme.layout.spacing.s500};
`

interface Props {
  guestType: GuestType
}
export const GuestTypesSubSection: React.FC<Props> = ({guestType}) => {
  const {isMobile} = useDeviceLayout()
  if (!guestType) return null

  const guestTypePercentages = calculateGuestTypePercentages(guestType)

  return (
    <>
      <ReviewsTrackClick
        stopPropagation
        element={SelectedElementType.GuestTypesHeader}
        entity={Entity.HotelDetailsReviewsSection}
      >
        <Box paddingBottom="s500" className="--guest-types-sub-section-title">
          <Text variant="titleM" tag="h3">
            <FormattedMessageWrapper
              id="reviews.whoStaysHere"
              defaultMessage="Who stays here?"
            />
          </Text>
        </Box>
      </ReviewsTrackClick>
      <HorizontalScrollWrapper className="--guest-types-sub-section-icons">
        <HorizontalScroll
          className="--guest-types-sub-section-icons-scroll"
          columnGap={isMobile ? 's600' : 's700'}
        >
          {guestTypePercentages.map(({key, value}) => (
            <GuestTypeBadge key={key} guestTypeKey={key} value={value} />
          ))}
        </HorizontalScroll>
      </HorizontalScrollWrapper>
    </>
  )
}
